export default __webpack_public_path__ + "static/moment_4-3dcf213e9714450aafa61b1c940c3cdf.jpg";